export const statusStyles = {
  Active: {
    text: 'text-green-700',
    bg: 'bg-green-50',
  },
  Inactive: {
    text: 'text-gray-700',
    bg: 'bg-gray-50',
  },
  Blocked: {
    text: 'text-red-700',
    bg: 'bg-red-50',
  },
  Deleted: {
    text: 'text-red-700',
    bg: 'bg-red-50',
  },
  Pending: {
    text: 'text-yellow-700',
    bg: 'bg-yellow-50',
  },
};
